














































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

import { Surface } from '@/components/atoms';
import CloseModalIcon from '@/components/icons/CloseModal.vue';
import CustomSelect from '@/components/CustomSelect/CustomSelect.vue';
import {
  CustomSelectModel,
  CustomSelectGroup,
  CustomSelectOption
} from '@/components/CustomSelect/CustomSelectModel';
import TextArea from '@/components/atoms/TextArea/TextArea.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';

import OffersService from '@/api/OffersService';

import eventBus from '@/utils/eventBus';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    CloseModalIcon,
    Surface,
    CustomSelect,
    TextArea,
    FilledButton
  }
})
export default class SendAnOfferModal extends Vue {
  @Prop(String) customerName!: string;
  @Prop(String) customerId!: string;

  offerService: OffersService = new OffersService();
  page = 0;
  hasNoMoreOffer = false;
  title = '';
  categories: CustomSelectOption[] = [];
  debounce: any = {};
  isLoading = false;
  disabled = true;
  message = '';
  offerSelected: CustomSelectOption[] = [];

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get initCategories() {
    return new CustomSelectModel(
      [new CustomSelectGroup(this.categories, '')],
      'Offers',
      true,
      false,
      false,
      true
    );
  }

  created() {
    this.disabled = true;
    this.hasNoMoreOffer = false;
    this.loadOffers();

    segmentIo.modal('Send Offer');
    document.onkeydown = this.handleOnkeydown;
  }

  @Watch('$route')
  onRouteChange() {
    this.onClose();
  }

  loadMore() {
    this.page += 5;
    this.loadOffers();
  }

  searchChange(event: string) {
    this.hasNoMoreOffer = false;
    this.page = 0;
    this.title = event;
    this.categories = [];
    clearTimeout(this.debounce);
    this.debounce = setTimeout(() => {
      this.loadOffers();
    }, 300);
  }

  loadOffers() {
    if (this.hasNoMoreOffer) return;
    if (this.isLoading) return;
    this.isLoading = true;
    this.offerService
      .getOffers(
        '',
        '',
        `&status=active&skip=${this.page}&limit=10&search=${this.title}&`,
        ''
      )
      .then((res: any) => {
        let categories = res.data.items.filter(
          (item: any) => item.status === 'active'
        );
        categories = categories.map(
          (item: any) => new CustomSelectOption(item.id, item.title)
        );
        this.categories = categories;
        if (res.data.links.next === null) this.hasNoMoreOffer = true;
      })
      .catch(() => {})
      .finally(() => {
        this.isLoading = false;
      });
  }

  categoryChanged(item: CustomSelectOption[]) {
    this.disabled = false;
    this.offerSelected = item;
  }

  onClose() {
    eventBus.$emit('closeModal');
  }

  async handleSendOffer(
    offer: Record<string, any>,
    payload: { customersIds: string[]; message: string }
  ) {
    const response = await this.offerService.sendOffer(offer.uuid, payload);

    if (response.status !== 200) return;

    eventBus.$emit('reloadCustomerDetail');

    this.$notification(
      `${offer.label} offer has been sent to ${this.customerName}`
    );
  }

  async handleSubmit() {
    this.onClose();

    const [offer] = this.offerSelected;

    const response = await this.$showConfirmDialog({
      title: 'Send Offer',
      description: `
        You are about to send the offer <b>${offer.label} </b>to<b> ${
        this.customerName
      }</b>
      <br />
      <br />
      Would you like to proceed?
      `,
      cancelButtonText: 'No',
      confirmButtonText: 'Yes',
      icon: 'icon-send-offer'
    });

    if (response === 'confirm') {
      const payload = {
        message: !this.message
          ? `${this.businessInfo.name} has just awarded you the "${
              offer.label
            }" offer`
          : this.message,
        customersIds: [this.customerId]
      };

      this.handleSendOffer(offer, payload);
    }
  }

  handleOnkeydown({ key }: KeyboardEvent) {
    if (key === 'Escape') {
      this.onClose();
    }
  }
}
